<section class="flex flex-col gap-3">
  <div
    swiper
    (init)="swiper = $event"
    [options]="swiperOptions"
    (realIndex)="swiperIndex.set($event)"
    class="overflow-hidden h-[18.75rem]"
  >
    <div class="swiper-wrapper flex h-full">
      @for (image of imageUrls(); track $index) {
        <img class="swiper-slide h-full object-cover" [src]="image" />
      }
    </div>
  </div>
  <div class="flex gap-2 justify-center items-center">
    @for (i of imageUrls(); track $index) {
      <div
        [ngClass]="$index === swiperIndex() ? 'bg-primary' : 'bg-gray-200'"
        class="rounded-full size-2"
      ></div>
    }
  </div>
</section>
